"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prizmNext = exports.createPrizmNextTheme = void 0;
var _lodash = _interopRequireDefault(require("lodash.merge"));
var _colors = _interopRequireDefault(require("./colors"));
var _typography = _interopRequireDefault(require("./typography"));
var _spacing = _interopRequireDefault(require("./spacing"));
var _elevation = _interopRequireDefault(require("./elevation"));
const menu = {
  expanded: '240px',
  collapsed: '48px'
};
const header = {
  height: '48px'
};
const createPrizmNextTheme = (primitives = {}, overrides = {}, extra = {}) => {
  const colors = (0, _lodash.default)(_colors.default, primitives.colors);
  const typography = (0, _lodash.default)(_typography.default, primitives.typography);
  const spacing = (0, _lodash.default)(_spacing.default, primitives.spacing);
  const elevation = (0, _lodash.default)(_elevation.default, primitives.elevation);
  const theme = {
    name: 'prizm-next',
    fonts: {
      preferred: typography.bodyMediumInterface.fontFamily,
      secondary: typography.bodyMediumInterface.fontFamily
    },
    fontSizes: {
      base: '1rem'
    },
    typography,
    spacing,
    elevation,
    AppFrame: {
      bellWidget: {
        width: '352px',
        boxShadow: elevation.el2,
        header: {
          fontFamily: typography.titleMedium.fontFamily,
          fontSize: typography.titleMedium.fontSize,
          fontWeight: typography.titleMedium.fontWeight,
          lineHeight: '40px',
          height: '40px',
          padding: `0 ${spacing.m1}`,
          textAlign: 'center',
          textTransform: 'capitalize'
        },
        footer: {
          fontFamily: typography.bodyMediumInterface.fontFamily,
          fontSize: typography.bodyMediumInterface.fontSize,
          fontWeight: typography.bodyMediumInterface.fontWeight,
          lineHeight: typography.bodyMediumInterface.lineHeight,
          height: '56px'
        },
        placeholder: {
          fontFamily: typography.bodyMediumInterface.fontFamily,
          fontSize: typography.bodyMediumInterface.fontSize,
          fontWeight: typography.bodyMediumInterface.fontWeight,
          lineHeight: typography.bodyMediumInterface.lineHeight
        }
      },
      header: {
        height: header.height,
        searchPanel: {
          inputHeight: '32px',
          inputLeftMaring: 0,
          selectedCharFontWeight: 700
        },
        nav: {
          iconPadding: '0 6px'
        }
      },
      menu: {
        expandedWidth: menu.expanded,
        collapsedWidth: menu.collapsed,
        border: 0,
        header: {
          height: header.height
        },
        itemContainer: {
          padding: '0',
          paddingLeft: '16px',
          collapsedPadding: '0',
          height: '48px',
          badgeHeight: '40px',
          width: menu.expanded,
          marginBottom: '0'
        },
        itemTitle: {
          fontSize: typography.bodyMediumInterface.fontSize,
          fontWeight: typography.bodyMediumInterface.fontWeight,
          fontWeightBold: typography.bodyMediumInterface.fontWeight,
          letterSpacing: typography.bodyMediumInterface.letterSpacing,
          lineHeight: typography.bodyMediumInterface.lineHeight,
          color: '#000',
          opacity: '0.60',
          hover: {
            opacity: 1
          }
        },
        itemIcon: {
          width: menu.collapsed,
          opacity: '0.65',
          lineHeight: '32px',
          margin: '0'
        },
        itemArrowContainer: {
          width: '48px',
          height: '48px',
          border: '1px solid #aabfd84d'
        },
        itemArrow: {
          width: '16px',
          height: '16px'
        },
        submenu: {
          width: menu.expanded,
          sectionPadding: '15px 16px',
          dividerHeight: '1px',
          sectionFontSize: typography.titleSmall.fontSize,
          sectionFontWeight: typography.titleSmall.fontWeight,
          sectionLetterSpacing: typography.titleSmall.letterSpacing,
          sectionLineHeight: typography.titleSmall.lineHeight,
          sectionTextTransform: 'uppercase',
          sectionTitleOpacity: '0.65'
        },
        footer: {
          horizontalPadding: '8px'
        }
      },
      breadcrumbs: {
        fontSize: typography.titleMedium.fontSize,
        fontFamily: typography.titleMedium.fontFamily,
        fontWeight: typography.titleMedium.fontWeight,
        lineHeight: typography.titleMedium.lineHeight,
        popover: {
          shadow: '0',
          padding: '5px 0',
          itemPadding: '8px 5px',
          itemFontFamily: typography.titleSmall.fontFamily,
          itemFontSize: '12px',
          itemFontWeight: '500',
          itemLineHeight: '1'
        }
      },
      snack: {
        fontSize: '12px',
        fontWeight: 500,
        containerWidth: '352px',
        closeBtnHeight: '24px',
        closeBtnWidth: '24px',
        readBtnHeight: '24px',
        readBtnWidth: '24px',
        topPadding: spacing.s2,
        body: {
          fontSize: typography.button.fontSize,
          fontWeight: typography.button.fontWeight,
          lineHeight: typography.button.lineHeight,
          padding: `${spacing.s3}`,
          contentMargin: `0 ${spacing.s4}`
        },
        timestamp: {
          fontSize: '10px',
          fontWeight: 300,
          lineHeight: 'normal'
        },
        button: {
          fontSize: '10px',
          fontWeight: 500,
          lineHeight: '16px',
          height: 'auto',
          btnMargin: `0 ${spacing.s3} 0 0`
        },
        placeholder: {
          fontSize: '14px',
          fontWeight: 300
        }
      }
    },
    buttons: {
      fontFamily: typography.button.fontFamily,
      default: {
        fontSize: typography.button.fontSize,
        fontWeight: typography.button.fontWeight,
        height: '48px',
        width: '100%',
        minWidth: '150px',
        minWidthIconOnly: '32px',
        textTransform: typography.button.textTransform,
        textTransformFirstLetter: typography.button.textTransform,
        letterSpacing: typography.button.letterSpacing,
        lineHeight: typography.button.lineHeight,
        padding: '16px'
      },
      inline: {
        fontSize: typography.button.fontSize,
        fontWeight: typography.button.fontWeight,
        height: '32px',
        width: 'auto',
        minWidth: 'initial',
        minWidthIconOnly: 'initial',
        textTransform: typography.button.textTransform,
        textTransformFirstLetter: typography.button.textTransform,
        letterSpacing: typography.button.letterSpacing,
        lineHeight: typography.button.lineHeight,
        padding: '8px 16px',
        iconPadding: '12px',
        borderRadius: '4px',
        boxShadow: elevation.el2,
        margin: '0px',
        dropdownButtonPadding: '4px 8px 4px 16px',
        dropdownButtonIconMargin: '0 0 0 8px',
        splitDropdownDropPadding: '4px'
      },
      link: {
        fontSize: typography.button.fontSize,
        fontWeight: typography.button.fontWeight,
        textTransform: typography.button.textTransform,
        letterSpacing: typography.button.letterSpacing,
        lineHeight: typography.button.lineHeight
      }
    },
    buttonGroup: {
      groupMarginFramed: '1px',
      groupMarginInline: '8px',
      groupPadding: '0',
      contextMenu: {
        trigger: {
          width: '48px',
          margin: 0,
          borderWidth: 0,
          borderStyle: 'solid'
        },
        popup: {
          padding: 0
        },
        item: {
          fontFamily: typography.button.fontFamily,
          fontSize: typography.button.fontSize,
          fontWeight: typography.button.fontWeight,
          lineHeight: '18px',
          letterSpacing: typography.button.letterSpacing,
          height: '48px',
          textTransform: 'uppercase',
          borderWidth: '0 0 1px 0',
          borderStyle: 'solid'
        }
      }
    },
    card: {
      borderRadius: '8px',
      title: {
        fontSize: typography.headlineSmall.fontSize,
        fontWeight: typography.headlineSmall.fontWeight,
        lineHeight: typography.headlineSmall.lineHeight
      },
      description: {
        fontWeight: '300'
      }
    },
    modals: {
      padding: '0',
      headerHeight: '48px',
      headerPadding: '8px 12px 8px 16px',
      headerTitlePosition: 'left',
      confirmAlignment: 'center',
      borderRadius: '8px',
      title: {
        fontFamily: typography.titleMedium.fontFamily,
        fontSize: typography.titleMedium.fontSize,
        fontWeight: typography.titleMedium.fontWeight,
        lineHeight: typography.titleMedium.lineHeight,
        letterSpacing: typography.titleMedium.letterSpacing,
        textTransform: 'capitalize',
        padding: '0px',
        actionsTop: '8px',
        actionsRight: '12px'
      },
      content: {
        padding: spacing.m1,
        fontFamily: typography.bodyMediumParagraph.fontFamily,
        fontSize: typography.bodyMediumParagraph.fontSize,
        fontWeight: typography.bodyMediumParagraph.fontWeight,
        lineHeight: typography.bodyMediumParagraph.lineHeight
      }
    },
    accordion: {
      badge: {
        fontSize: typography.tooltipLabel.fontSize,
        fontFamily: typography.tooltipLabel.fontFamily,
        fontWeight: typography.tooltipLabel.fontWeight,
        lineHeight: '17px',
        letterSpacing: typography.tooltipLabel.letterSpacing,
        height: '17px',
        borderRadius: '14px',
        padding: '0 7px',
        right: '46px'
      },
      arrowIcon: {
        height: '13px',
        width: '13px'
      },
      header: {
        fontSize: typography.titleSmall.fontSize,
        fontFamily: typography.titleSmall.fontFamily,
        fontWeight: typography.titleSmall.fontWeight,
        lineHeight: typography.titleSmall.lineHeight,
        letterSpacing: typography.titleSmall.letterSpacing,
        textTransform: typography.titleSmall.textTransform,
        borderTopWidth: '0px',
        borderBottomWidth: '1px',
        borderBottomWidthActive: '1px',
        height: '48px',
        padding: '0px 16px'
      }
    },
    panel: {
      fontSize: typography.bodyMediumInterface.fontSize,
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      lineHeight: '40px',
      letterSpacing: typography.bodyMediumInterface.letterSpacing,
      textTransform: 'capitalize'
    },
    numberField: {
      fontSize: typography.bodyMediumInterface.fontSize,
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      lineHeight: typography.bodyMediumInterface.lineHeight,
      letterSpacing: typography.bodyMediumInterface.letterSpacing,
      height: '32px',
      label: {
        fontSize: typography.bodyMediumInterface.fontSize,
        fontFamily: typography.bodyMediumInterface.fontFamily,
        fontWeight: typography.bodyMediumInterface.fontWeight,
        lineHeight: typography.bodyMediumInterface.lineHeight,
        letterSpacing: typography.bodyMediumInterface.letterSpacing,
        marginBottom: spacing.s2
      },
      description: {
        fontSize: '12px',
        fontWeight: 300,
        marginTop: spacing.s1
      },
      error: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: '14px'
      }
    },
    numericInput: {
      fontSize: typography.bodyMediumInterface.fontSize,
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      lineHeight: typography.bodyMediumInterface.lineHeight,
      letterSpacing: typography.bodyMediumInterface.letterSpacing,
      height: '32px',
      padding: `0 ${spacing.s2}`,
      label: {
        fontSize: typography.bodyMediumInterface.fontSize,
        fontFamily: typography.bodyMediumInterface.fontFamily,
        fontWeight: typography.bodyMediumInterface.fontWeight,
        lineHeight: typography.bodyMediumInterface.lineHeight,
        letterSpacing: typography.bodyMediumInterface.letterSpacing,
        marginBottom: spacing.s2
      },
      description: {
        fontSize: '12px',
        fontWeight: 300,
        marginTop: spacing.s1
      },
      error: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: '14px'
      }
    },
    radio: {
      fontSize: typography.bodyMediumInterface.fontSize,
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      lineHeight: typography.bodyMediumInterface.lineHeight,
      size: '16px',
      labelShift: spacing.s4,
      bottomMargin: spacing.s4,
      label: {
        fontSize: typography.bodyMediumInterface.fontSize,
        fontFamily: typography.bodyMediumInterface.fontFamily,
        fontWeight: typography.bodyMediumInterface.fontWeight,
        lineHeight: typography.bodyMediumInterface.lineHeight,
        marginBottom: '10px'
      },
      error: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: '14px'
      }
    },
    switch: {
      fontSize: typography.bodyMediumInterface.fontSize,
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      lineHeight: typography.bodyMediumInterface.lineHeight,
      thumbSize: '12px',
      hoverThumbSize: '14px',
      thumbShift: '2px',
      labelShift: spacing.s3,
      width: '28px',
      height: '16px',
      radius: '8px',
      label: {
        fontSize: typography.bodyMediumInterface.fontSize,
        fontFamily: typography.bodyMediumInterface.fontFamily,
        fontWeight: typography.bodyMediumInterface.fontWeight,
        lineHeight: typography.bodyMediumInterface.lineHeight,
        marginBottom: '10px'
      },
      error: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: '14px'
      }
    },
    tagsInput: {
      fontSize: '12px',
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: 400,
      lineHeight: '22px',
      height: '24px',
      letterSpacing: typography.bodyMediumInterface.letterSpacing,
      tagBorderRadius: '3px',
      containerPadding: '0 4px',
      containerGap: '4px',
      inputPadding: '0 4px',
      tagHeight: '24px',
      tagInnerPadding: '4px 4px 4px 8px',
      tagInnerGap: '4px',
      placeholder: {
        fontSize: typography.bodyMediumInterface.fontSize,
        fontWeight: typography.bodyMediumInterface.fontWeight,
        lineHeight: typography.bodyMediumInterface.lineHeight,
        letterSpacing: typography.bodyMediumInterface.letterSpacing
      },
      label: {
        fontSize: typography.bodyMediumInterface.fontSize,
        fontWeight: typography.bodyMediumInterface.fontWeight,
        lineHeight: typography.bodyMediumInterface.lineHeight,
        letterSpacing: typography.bodyMediumInterface.letterSpacing,
        marginBottom: spacing.s2
      },
      description: {
        fontSize: typography.titleSmall.fontSize,
        fontWeight: typography.titleSmall.fontWeight,
        lineHeight: typography.titleSmall.lineHeight,
        letterSpacing: typography.titleSmall.letterSpacing,
        marginTop: spacing.s1
      },
      error: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: '14px'
      }
    },
    dateDropdown: {
      fontSize: typography.bodyMediumInterface.fontSize,
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      lineHeight: typography.bodyMediumInterface.lineHeight,
      letterSpacing: typography.bodyMediumInterface.letterSpacing,
      height: '32px',
      padding: `6px ${spacing.s2}`,
      label: {
        fontSize: typography.bodyMediumInterface.fontSize,
        fontWeight: typography.bodyMediumInterface.fontWeight,
        lineHeight: typography.bodyMediumInterface.lineHeight,
        letterSpacing: typography.bodyMediumInterface.letterSpacing,
        marginBottom: spacing.s2
      },
      description: {
        fontSize: typography.caption.fontSize,
        fontFamily: typography.caption.fontFamily,
        fontWeight: typography.caption.fontWeight,
        lineHeight: typography.caption.lineHeight,
        letterSpacing: typography.caption.letterSpacing,
        marginTop: spacing.s1
      },
      error: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: '14px'
      }
    },
    calendar: {
      borderRadius: '8px',
      width: '288px',
      monthControls: {
        height: '40px',
        padding: '8px 0px',
        margin: '0px 8px',
        borderBottomWidth: '1px',
        label: {
          fontSize: typography.bodyMediumInterface.fontSize,
          fontFamily: typography.bodyMediumInterface.fontFamily,
          fontWeight: typography.bodyMediumInterface.fontWeight,
          lineHeight: typography.bodyMediumInterface.lineHeight,
          letterSpacing: typography.bodyMediumInterface.letterSpacing
        }
      },
      weekDays: {
        padding: '12px 4px',
        label: {
          fontSize: typography.caption.fontSize,
          fontFamily: typography.caption.fontFamily,
          fontWeight: 500,
          lineHeight: typography.caption.lineHeight,
          letterSpacing: typography.caption.letterSpacing
        }
      },
      days: {
        containerPadding: '0px 4px 4px',
        width: '36px',
        height: '36px',
        margin: '2px',
        padding: '10px 2px',
        borderRadius: '4px',
        label: {
          fontSize: typography.bodyMediumInterface.fontSize,
          fontFamily: typography.bodyMediumInterface.fontFamily,
          fontWeight: typography.bodyMediumInterface.fontWeight,
          lineHeight: typography.bodyMediumInterface.lineHeight,
          letterSpacing: typography.bodyMediumInterface.letterSpacing
        }
      },
      year: {
        fontSize: typography.bodyMediumInterface.fontSize,
        fontFamily: typography.bodyMediumInterface.fontFamily,
        fontWeight: typography.bodyMediumInterface.fontWeight,
        lineHeight: '32px',
        letterSpacing: typography.bodyMediumInterface.letterSpacing
      },
      time: {
        inputsPadding: '0 6px',
        buttonPadding: '8px 6px'
      }
    },
    datePicker: {
      fontSize: typography.bodyMediumInterface.fontSize,
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      caption: {
        fontSize: typography.bodyMediumInterface.fontSize,
        fontFamily: typography.bodyMediumInterface.fontFamily,
        fontWeight: typography.bodyMediumInterface.fontWeight,
        lineHeight: typography.bodyMediumInterface.lineHeight
      },
      weekdays: {
        fontSize: typography.bodyMediumInterface.fontSize,
        fontFamily: typography.bodyMediumInterface.fontFamily,
        fontWeight: 500
      }
    },
    textField: {
      fontSize: typography.bodyMediumInterface.fontSize,
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      lineHeight: typography.bodyMediumInterface.lineHeight,
      letterSpacing: typography.bodyMediumInterface.letterSpacing,
      borderWidth: '1px',
      height: '32px',
      inputPadding: spacing.s2,
      areaPadding: `${spacing.s2} 10px`,
      label: {
        fontSize: typography.bodyMediumInterface.fontSize,
        fontWeight: typography.bodyMediumInterface.fontWeight,
        lineHeight: typography.bodyMediumInterface.lineHeight,
        letterSpacing: typography.bodyMediumInterface.letterSpacing,
        marginBottom: spacing.s2
      },
      description: {
        fontSize: '12px',
        fontWeight: 300,
        marginTop: spacing.s1
      },
      error: {
        fontSize: '12px',
        fontWeight: 300,
        marginTop: spacing.s1
      },
      passwordIcon: {
        height: '24px',
        width: '24px'
      }
    },
    toast: {
      fontSize: typography.titleMedium.fontSize,
      fontFamily: typography.titleMedium.fontFamily,
      fontWeight: typography.titleMedium.fontWeight,
      lineHeight: typography.titleMedium.lineHeight,
      letterSpacing: typography.bodyMediumInterface.letterSpacing,
      iconHeight: '32px',
      iconWidth: '32px',
      iconMargin: `0 ${spacing.s4}`,
      toastContainerHeight: '48px',
      buttonBorder: 'none',
      buttonBorderHover: 'none',
      buttonBorderActive: 'none',
      btnContainerHeight: '100%',
      btnContainerMargin: '0',
      btnActionMargin: '0 1px 0 0'
    },
    tooltip: {
      fontFamily: typography.caption.fontFamily,
      fontSize: typography.caption.fontSize,
      fontWeight: typography.caption.fontWeight,
      lineHeight: typography.caption.lineHeight,
      letterSpacing: typography.caption.letterSpacing,
      padding: '6px 8px',
      borderRadius: '3px'
    },
    checkbox: {
      fontSize: typography.bodyMediumInterface.fontSize,
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      lineHeight: typography.bodyMediumInterface.lineHeight,
      size: '16px',
      bottomMargin: spacing.s1,
      labelShift: spacing.s4,
      borderRadius: '2px',
      label: {
        fontFamily: typography.bodyMediumInterface.fontFamily,
        fontSize: typography.bodyMediumInterface.fontSize,
        fontWeight: typography.bodyMediumInterface.fontWeight,
        lineHeight: typography.bodyMediumInterface.lineHeight,
        marginBottom: '10px'
      },
      error: {
        fontFamily: typography.bodyMediumInterface.fontFamily,
        fontSize: '12px',
        fontWeight: '300',
        lineHeight: '14px'
      }
    },
    contextMenu: {
      fontSize: typography.bodyMediumInterface.fontSize,
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      lineHeight: typography.bodyMediumInterface.lineHeight,
      letterSpacing: typography.bodyMediumInterface.letterSpacing,
      width: '200px',
      itemHeight: '32px',
      containerPadding: '4px 0px',
      menuItemPadding: '0 12px',
      menuItemMargin: '0 4px',
      menuItemBorderRadius: '6px',
      borderRadius: '8px',
      dividerMargin: '4px 0px',
      submenuTop: '-4px',
      submenuArrowIcon: {
        height: '16px',
        width: '16px',
        arrowMargin: '0 0 0 15px'
      },
      toggler: {
        display: 'inline-block',
        width: 'auto',
        height: 'auto',
        flexDirection: 'initial',
        alignItems: 'initial',
        justifyContent: 'initial'
      }
    },
    dropdown: {
      fontSize: typography.bodyMediumInterface.fontSize,
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      lineHeight: typography.bodyMediumInterface.lineHeight,
      letterSpacing: typography.bodyMediumInterface.letterSpacing,
      marginLeft: '24px',
      height: '32px',
      padding: `0 ${spacing.s2}`,
      borderWidth: '0 0 1px 0',
      label: {
        fontFamily: typography.bodyMediumInterface.fontFamily,
        fontSize: typography.bodyMediumInterface.fontSize,
        fontWeight: typography.bodyMediumInterface.fontWeight,
        lineHeight: typography.bodyMediumInterface.lineHeight,
        letterSpacing: typography.bodyMediumInterface.letterSpacing,
        marginBottom: spacing.s2
      },
      description: {
        fontSize: '12px',
        fontWeight: 300,
        marginTop: spacing.s1
      },
      error: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: '14px'
      },
      tag: {
        borderRadius: '0',
        fontSize: '14px',
        fontFamily: typography.bodyMediumInterface.fontFamily,
        fontWeight: '300',
        height: '24px',
        margin: '3px',
        padding: '0 24px 0 10px'
      },
      options: {
        padding: `${spacing.s1} 0`,
        shadow: elevation.el2,
        itemHeight: '32px',
        itemPadding: '8px 8px 8px 16px',
        selectedFontWeight: '300',
        borderRadius: '8px',
        selectedIcon: {
          height: '16px',
          width: '16px'
        }
      }
    },
    filterLayout: {
      fontSize: typography.bodyMediumInterface.fontSize,
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      lineHeight: typography.bodyMediumInterface.lineHeight,
      headerPadding: '0 20px',
      bodyPadding: '0px',
      boxShadow: elevation.el2,
      applyPadding: 0,
      borderRadius: '8px',
      containerWidth: '280px'
    },
    inlineDropdown: {
      fontSize: typography.bodyMediumInterface.fontSize,
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      lineHeight: typography.bodyMediumInterface.lineHeight,
      letterSpacing: typography.bodyMediumInterface.letterSpacing,
      selectedFontWeight: 500,
      boxShadow: elevation.el2,
      itemHeight: '30px',
      itemPadding: `0 ${spacing.s4}`,
      width: '165px'
    },
    tabs: {
      label: {
        fontSize: typography.bodyMediumInterface.fontSize,
        fontFamily: typography.bodyMediumInterface.fontFamily,
        fontWeight: typography.bodyMediumInterface.fontWeight,
        lineHeight: typography.bodyMediumInterface.lineHeight,
        primaryLineHeight: typography.bodyMediumParagraph.lineHeight,
        letterSpacing: typography.bodyMediumInterface.letterSpacing,
        primaryHeight: '48px',
        primaryFontWeight: 500,
        secondaryHeight: '48px',
        primaryPadding: '16px 14px',
        primaryActivePaddingTop: '13px',
        secondaryPadding: '16px 0'
      },
      navigation: {
        primaryPosition: 'flex-start',
        secondaryPosition: 'center',
        primaryPaddingTop: '0px'
      },
      badge: {
        lineHeight: '17px',
        fontWeight: 300,
        borderRadius: '14px',
        height: '17px'
      },
      spacingBetweenTabs: '17px'
    },
    verticalTabs: {
      fontSize: typography.bodyMediumInterface.fontSize,
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      lineHeight: '40px',
      letterSpacing: typography.bodyMediumInterface.letterSpacing
    },
    pagination: {
      fontSize: typography.bodyMediumInterface.fontSize,
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      lineHeight: typography.bodyMediumInterface.lineHeight,
      letterSpacing: typography.bodyMediumInterface.letterSpacing,
      currentPage: {
        width: '30px',
        height: '30px',
        border: 'none'
      },
      topPagination: {
        dropdownMinWidth: '54px'
      },
      bottomPagination: {
        fontSize: typography.bodyMediumInterface.fontSize,
        fontFamily: typography.bodyMediumInterface.fontFamily,
        fontWeight: typography.bodyMediumInterface.fontWeight,
        lineHeight: '20px',
        letterSpacing: typography.bodyMediumInterface.letterSpacing,
        itemPadding: '0 8px',
        itemMargin: '0 6px',
        padding: '16px 0'
      },
      action: {
        height: 20,
        width: 11
      }
    },
    table: {
      header: {
        fontFamily: typography.bodyMediumInterface.fontFamily,
        fontSize: typography.bodyMediumInterface.fontSize,
        fontWeight: typography.bodyMediumInterface.fontWeight,
        lineHeight: typography.bodyMediumInterface.lineHeight,
        letterSpacing: typography.bodyMediumInterface.letterSpacing
      },
      column: {
        fontFamily: typography.bodyMediumInterface.fontFamily,
        fontSize: typography.bodyMediumInterface.fontSize,
        fontWeight: typography.bodyMediumInterface.fontWeight,
        lineHeight: typography.bodyMediumInterface.lineHeight,
        letterSpacing: typography.bodyMediumInterface.letterSpacing,
        padding: '0 16px'
      },
      row: {
        height: '40px'
      }
    },
    label: {
      fontSize: typography.bodyMediumInterface.fontSize,
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      lineHeight: typography.bodyMediumInterface.lineHeight,
      letterSpacing: typography.bodyMediumInterface.letterSpacing
    },
    stepper: {
      height: '48px',
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontSize: typography.bodyMediumInterface.fontSize,
      lineHeight: typography.bodyMediumInterface.lineHeight,
      fontWeight: typography.bodyMediumInterface.fontWeight,
      chevronIconWidth: '24px',
      chevronIconHeight: '24px',
      border: '1px solid transparent',
      borderHover: `1px solid ${colors.primary.primary40}`,
      borderSelected: `3px solid ${colors.primary.primary40}`,
      itemPadding: '8px 0px 16px 0px',
      itemPaddingSelected: '8px 0px 14px 0px',
      successIconHeight: '16px',
      successIconWidth: '16px',
      stepIndicator: {
        width: '16px',
        height: '16px',
        borderRadius: '4px',
        fontFamily: typography.caption.fontFamily,
        fontSize: typography.caption.fontSize,
        lineHeight: typography.caption.lineHeight,
        fontWeight: 500
      }
    },
    badge: {
      badgeHeight: '16px',
      badgeWidth: '16px',
      badgeHeightDot: '8px',
      badgeWidthDot: '8px',
      fontSize: typography.caption.fontSize,
      fontWeight: typography.caption.fontWeight,
      lineHeight: typography.caption.lineHeight,
      fontFamily: typography.caption.fontFamily
    },
    textTag: {
      height: '24px',
      minWidth: '16px',
      borderRadius: '14px',
      padding: '4px 12px',
      fontSize: typography.caption.fontSize,
      fontWeight: typography.caption.fontWeight,
      lineHeight: typography.caption.lineHeight,
      fontFamily: typography.caption.fontFamily,
      letterSpacing: typography.caption.letterSpacing
    },
    progressBar: {
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontSize: typography.bodyMediumInterface.fontSize,
      lineHeight: typography.bodyMediumInterface.lineHeight,
      fontWeight: typography.bodyMediumInterface.fontWeight
    },
    slider: {
      fontFamily: typography.bodyMediumInterface.fontFamily,
      fontSize: typography.bodyMediumInterface.fontSize,
      lineHeight: typography.bodyMediumInterface.lineHeight,
      fontWeight: typography.bodyMediumInterface.fontWeight
    },
    contentSwitcher: {
      borderRadius: '4px',
      itemHeight: '24px',
      innerPadding: '4px 16px',
      fontSize: typography.caption.fontSize,
      fontWeight: typography.caption.fontWeight,
      letterSpacing: typography.caption.letterSpacing,
      lineHeight: typography.caption.lineHeight,
      fontFamily: typography.caption.fontFamily
    },
    chip: {
      padding: '5px 12px',
      borderRadius: '16px',
      fontSize: typography.titleMedium.fontSize,
      fontWeight: typography.titleMedium.fontWeight,
      letterSpacing: typography.titleMedium.letterSpacing,
      lineHeight: typography.titleMedium.lineHeight,
      fontFamily: typography.titleMedium.fontFamily
    },
    iconButton: {
      padding: '0px',
      borderRadius: '4px',
      iconWidth: '32px',
      iconHeight: '32px',
      tabIconOffset: '-5px'
    },
    colors: {
      palette: _colors.default,
      common: {
        outlineColor: 'transparent',
        outlineLinkColor: colors.primary50,
        disabledColor: colors.neutral.neutral60
      },
      appFrame: {
        shimmer: {
          placeholder: {
            header: {
              bg: colors.primary.primary95,
              tint: colors.primary.primary90
            },
            menu: {
              bg: '#0e2966',
              tint: '#0b3b70'
            }
          }
        },
        bellWidget: {
          headerBg: colors.neutral.white100,
          headerBorderColor: colors.variant.variant95,
          headerTextColor: colors.variant.variant50,
          contentBg: colors.neutral.white100,
          itemDate: 'rgba(53, 65, 74, 0.5)',
          itemBorder: colors.variant.variant95,
          itemHoverBg: '#f2f6fa',
          itemUnreadBg: '#f6fafc',
          loaderColor: '#222',
          footerTextColor: colors.variant.variant50,
          placeholderColor: colors.variant.variant50
        },
        header: {
          bg: colors.surface.surface0,
          borderColor: colors.surface.surface3,
          menuToggler: colors.primary.primary40,
          icon: colors.neutral.white100,
          iconNav: colors.variant.variant40,
          iconNavHover: colors.variant.variant60,
          iconNavDisabled: colors.variant.variant80,
          badge: colors.neutral.white100,
          placeholder: colors.variant.variant40,
          badgeBg: '#f5a623',
          searchBorder: colors.primary.primary95,
          searchPlaceholder: colors.variant.variant40,
          searchPanelBg: colors.primary.primary20,
          searchPanelText: colors.neutral.white100,
          searchPanelHover: colors.primary.primary40,
          menuTogglerBg: colors.neutral.neutral80,
          logoBorder: '#051c2c',
          switcherHoverBg: '#f0f0f0',
          switcherIconColor: '#000',
          switcherDropdownBg: colors.neutral.white100,
          switcherDropdownItemHoverBg: '#f0f0f0',
          switcherActiveItemBorderColor: '#1f40e6',
          switcherLinkColor: '#000',
          switcherLinkHoverColor: '#1f40e6',
          moduleIconColor: colors.primary.primary40
        },
        menu: {
          toggler: colors.variant.variant80,
          line: 'rgb(170 191 216 / 25%)',
          bg: colors.primary.primary10,
          headerBg: colors.primary.primary10,
          borderColor: colors.primary.primary40,
          headerText: colors.neutral.white100,
          badgeBg: '#7adf67',
          delimiter: 'rgba(255, 255, 255, 0.6)',
          tooltipText: colors.neutral.white100,
          tooltipBg: colors.primary.primary40,
          itemIconColor: colors.neutral.white100,
          itemText: colors.neutral.white100,
          itemTextHover: colors.neutral.white100,
          itemActiveBg: colors.neutral.white100,
          itemActiveBadge: colors.accent.accent60,
          itemHoverBg: colors.primary.primary40,
          itemArrowIndicator: colors.neutral.white100,
          itemArrowAreaBorder: '#aabfd84d',
          groupBg: colors.primary.primary20,
          groupHoverBg: colors.primary.primary40,
          groupSeparator: 'rgba(170, 191, 216, 0.3)',
          placeholderBgColor: '#646d75',
          placeholderTintColor: '#848e96',
          submenuDivider: colors.primary.primary60,
          submenuSectionTitleColor: colors.neutral.white100,
          switcherBg: colors.primary.primary20,
          switcherHoverBg: colors.primary.primary40,
          switcherText: colors.neutral.white100,
          switcherHeaderTextColor: colors.neutral.white100,
          switcherLine: 'rgba(170, 191, 216, 0.3)',
          switcherShadow: 'rgba(0, 0, 0, 0.15)',
          switcherTogglerColor: colors.neutral.white100
        },
        snack: {
          closeBtn: colors.variant.variant70,
          closeBtnHover: '#222',
          readBtn: '#b2b2b2',
          readBtnHover: '#222',
          text: colors.variant.variant40,
          background: colors.neutral.white100,
          link: colors.primary.primary50,
          linkHover: colors.primary.primary40,
          categories: {
            critical: colors.error.error50,
            error: colors.error.error50,
            warning: colors.warning.warning80,
            success: colors.success.success60,
            info: colors.primary.primary40,
            default: colors.variant.variant70
          }
        },
        breadcrumbs: {
          containerBg: colors.surface.surface0,
          color: colors.primary.primary40,
          linkColor: colors.primary.primary40,
          hoverColor: colors.primary.primary20,
          separator: colors.primary.primary40,
          popoverBg: colors.primary.primary20,
          popoverItemColor: colors.neutral.white100,
          popoverItemLinkColor: colors.neutral.white100,
          popoverItemBorder: colors.primary.primary30,
          popoverItemHover: colors.primary.primary40,
          popoverItemTextHover: colors.neutral.white100
        }
      },
      button: {
        textColor: colors.neutral.white100,
        disabledBgColor: colors.neutral.neutral80,
        disabledSubBorderColor: colors.neutral.white100,
        primary: {
          textColor: colors.neutral.white100,
          linkColor: colors.primary.primary40,
          linkHoverColor: colors.primary.primary30,
          bgColor: colors.primary.primary40,
          hoverBgColor: colors.primary.primary30,
          activeBgColor: colors.primary.primary20,
          disabledTextColor: colors.neutral.white100,
          disabledBgColor: colors.neutral.neutral70,
          subBorderColor: colors.primary.primary70,
          linkArrowColor: colors.primary.primary40,
          dark: {
            textColor: colors.neutral.white100,
            linkColor: colors.primary.primary40,
            linkHoverColor: colors.primary.primary30,
            bgColor: colors.primary.primary40,
            hoverBgColor: colors.primary.primary30,
            activeBgColor: colors.primary.primary20,
            disabledTextColor: colors.neutral.white100,
            disabledBgColor: colors.neutral.neutral70,
            subBorderColor: colors.primary.primary70,
            linkArrowColor: colors.primary.primary40
          }
        },
        secondary: {
          textColor: colors.primary.primary20,
          linkColor: colors.primary.primary60,
          linkHoverColor: colors.primary.primary50,
          bgColor: colors.primary.primary90,
          hoverBgColor: colors.primary.primary80,
          activeBgColor: colors.primary.primary70,
          disabledTextColor: colors.neutral.neutral50,
          disabledBgColor: colors.neutral.neutral95,
          subBorderColor: colors.neutral.white100,
          linkArrowColor: colors.primary.primary60,
          dark: {
            textColor: colors.primary.primary20,
            linkColor: colors.primary.primary60,
            linkHoverColor: colors.primary.primary50,
            bgColor: colors.primary.primary90,
            hoverBgColor: colors.primary.primary80,
            activeBgColor: colors.primary.primary70,
            disabledTextColor: colors.neutral.neutral50,
            disabledBgColor: colors.neutral.neutral95,
            subBorderColor: colors.neutral.white100,
            linkArrowColor: colors.primary.primary60
          }
        },
        tertiary: {
          textColor: colors.primary.primary40,
          linkColor: colors.primary.primary40,
          linkHoverColor: colors.primary.primary30,
          bgColor: colors.neutral.white100,
          hoverBgColor: colors.primary.primary99,
          activeBgColor: colors.primary.primary95,
          border: `1px solid ${colors.primary.primary50}`,
          disabledTextColor: colors.neutral.neutral60,
          disabledBgColor: colors.neutral.white100,
          disabledBorder: `1px solid ${colors.neutral.neutral80}`,
          subBorderColor: colors.primary.primary50,
          linkArrowColor: colors.primary.primary40,
          dark: {
            textColor: colors.primary.primary40,
            linkColor: colors.primary.primary40,
            linkHoverColor: colors.primary.primary30,
            bgColor: colors.neutral.white100,
            hoverBgColor: colors.primary.primary99,
            activeBgColor: colors.primary.primary95,
            border: `1px solid ${colors.primary.primary50}`,
            disabledTextColor: colors.neutral.neutral60,
            disabledBgColor: colors.neutral.white100,
            disabledBorder: `1px solid ${colors.neutral.neutral80}`,
            subBorderColor: colors.primary.primary50,
            linkArrowColor: colors.primary.primary40
          }
        },
        ghost: {
          textColor: colors.primary.primary40,
          linkColor: colors.primary.primary40,
          linkHoverColor: colors.primary.primary30,
          bgColor: 'transparent',
          hoverBgColor: colors.primary.primary95,
          activeBgColor: colors.primary.primary90,
          border: 'none',
          disabledTextColor: colors.neutral.neutral60,
          disabledBgColor: 'transparent',
          disabledBorder: 'none',
          subBorderColor: 'none',
          linkArrowColor: colors.primary.primary40,
          dark: {
            textColor: colors.primary.primary40,
            linkColor: colors.primary.primary40,
            linkHoverColor: colors.primary.primary30,
            bgColor: 'transparent',
            hoverBgColor: colors.primary.primary95,
            activeBgColor: colors.primary.primary90,
            border: 'none',
            disabledTextColor: colors.neutral.neutral60,
            disabledBgColor: 'transparent',
            disabledBorder: 'none',
            subBorderColor: 'none',
            linkArrowColor: colors.primary.primary40
          }
        },
        danger: {
          textColor: colors.neutral.white100,
          linkColor: colors.error.error50,
          linkHoverColor: colors.error.error40,
          bgColor: colors.error.error50,
          hoverBgColor: colors.error.error40,
          activeBgColor: colors.error.error30,
          disabledTextColor: colors.neutral.white100,
          disabledBgColor: colors.neutral.neutral70,
          subBorderColor: colors.error.error80,
          linkArrowColor: colors.error.error50,
          dark: {
            textColor: colors.neutral.white100,
            linkColor: colors.error.error50,
            linkHoverColor: colors.error.error40,
            bgColor: colors.error.error50,
            hoverBgColor: colors.error.error40,
            activeBgColor: colors.error.error30,
            disabledTextColor: colors.neutral.white100,
            disabledBgColor: colors.neutral.neutral70,
            subBorderColor: colors.error.error80,
            linkArrowColor: colors.error.error50
          }
        }
      },
      buttonGroup: {
        contextMenu: {
          shadow: 'none',
          textColor: colors.primary.primary10,
          trigger: {
            bg: colors.primary.primary90,
            hoverBg: colors.primary.primary80,
            borderColor: colors.neutral.white100,
            icon: colors.primary.primary10
          },
          item: {
            text: colors.primary.primary10,
            bg: colors.primary.primary90,
            hoverBg: colors.primary.primary80,
            border: colors.neutral.white100
          }
        }
      },
      typography: {
        text: colors.variant.variant10
      },
      card: {
        containerBg: colors.neutral.white100,
        titleColor: colors.variant.variant40,
        descriptionColor: colors.variant.variant60,
        iconColor: colors.primary.primary40
      },
      splash: {
        background: colors.primary.primary40
      },
      verticalTabs: {
        text: colors.primary.primary40,
        textInactive: colors.variant.variant40,
        headerText: colors.variant.variant40,
        headerShadow: colors.neutral.neutral95,
        hoverBg: colors.surface1,
        hoverText: colors.primary.primary40,
        activeBg: 'transparent',
        activeBorder: colors.primary.primary40
      },
      accordion: {
        headerBg: colors.neutral.white100,
        headerActiveBg: colors.neutral.white100,
        headerHoverBg: colors.neutral.white100,
        borderColor: colors.neutral.neutral90,
        iconColor: colors.variant.variant40,
        iconHoverColor: colors.primary.primary40,
        iconActiveColor: colors.primary.primary40,
        labelColor: colors.variant.variant40,
        labelHoverColor: colors.primary.primary40,
        labelActiveColor: colors.primary.primary40
      },
      panel: {
        headerBg: colors.surface.surface1,
        headerText: colors.primary.primary30,
        connectorBg: '#f0f4f7',
        icon: colors.variant.variant40,
        border: colors.neutral.neutral90,
        bodyShadow: '0px 2px 16px 0px rgba(0, 0, 0, 0.05)'
      },
      tabs: {
        text: colors.variant.variant40,
        primaryText: colors.neutral.neutral10,
        primaryBg: colors.surface.surface1,
        primaryHoveredBg: colors.surface.surface3,
        primaryHoveredText: colors.variant.variant40,
        primaryHoveredShadow: 'rgba(0, 0, 0, 0.08)',
        primaryTabBg: colors.neutral.white100,
        primaryDisabledTabBg: colors.surface.surface0,
        primaryActiveBg: colors.neutral.white100,
        primaryActiveText: colors.primary.primary40,
        primaryActiveShadow: 'rgba(0, 0, 0, 0.16)',
        primaryActiveBorderColor: colors.primary.primary40,
        primaryBorderColor: colors.surface.surface3,
        secondaryBg: colors.neutral.white100,
        secondaryActiveText: colors.primary.primary40,
        secondaryShadow: colors.variant.variant95,
        badgeBg: colors.error.error40,
        badgeText: colors.neutral.white100
      },
      loadingIndicator: {
        overlayBg: 'rgba(255, 255, 255, 0.9)',
        externalBg: 'rgba(255, 255, 255, 0.1)',
        bg: colors.primary.primary40,
        circleBg: colors.primary.primary40,
        startColor: '#4679b4',
        stopColor: '#a7cffa'
      },
      unsupportedBrowser: {
        bg: colors.primary.primary40
      },
      forbidden: {
        bg: 'inherit',
        mainTextColor: '#000',
        secondaryTextColor: '#4d4d4d'
      },
      pageNotFound: {
        bg: 'inherit'
      },
      toast: {
        errorButtonText: colors.neutral.white100,
        errorText: colors.neutral.white100,
        errorBg: colors.error.error50,
        actionsErrorBg: colors.error.error40,
        dangerButtonText: colors.neutral.white100,
        dangerText: colors.neutral.white100,
        dangerBg: colors.error.error50,
        actionsDangerBg: colors.error.error40,
        warnButtonText: colors.neutral.white100,
        warnText: colors.neutral.white100,
        warnBg: colors.alert.alert60,
        actionsWarnBg: colors.alert.alert50,
        successButtonText: colors.neutral.white100,
        successText: colors.neutral.white100,
        successBg: colors.success.success60,
        actionsSuccessBg: colors.success.success50,
        neutralButtonText: colors.neutral.white100,
        neutralText: colors.neutral.white100,
        neutralBg: colors.neutral.neutral20,
        actionsNeutralBg: colors.neutral.neutral10,
        infoButtonText: colors.neutral.white100,
        infoText: colors.neutral.white100,
        infoBg: colors.primary.primary40,
        actionsInfoBg: colors.primary.primary30,
        warnIcon: colors.neutral.white100,
        errorIcon: colors.neutral.white100,
        dangerIcon: colors.neutral.white100,
        infoIcon: colors.neutral.white100,
        successIcon: colors.neutral.white100,
        neutralIcon: colors.neutral.white100
      },
      table: {
        text: colors.neutral.neutral10,
        selection: 'transparent',
        rowBorder: colors.neutral.neutral95,
        columnBorder: colors.neutral.neutral95,
        selectedBg: colors.surface.surface2
      },
      contextMenu: {
        itemText: colors.neutral.neutral10,
        divider: colors.neutral.neutral95,
        hoverBg: colors.primary.primary95,
        icon: colors.variant.variant40,
        bg: colors.neutral.white100,
        arrowIndicatorColor: colors.variant.variant40,
        togglerBg: 'transparent',
        customIconsColor: colors.variant.variant40,
        boxShadow: elevation.el2,
        itemTextDisabled: colors.neutral.neutral60,
        iconDisabled: colors.neutral.neutral70
      },
      splitter: {
        icon: colors.primary.primary40,
        bg: colors.variant.variant95,
        hoverBg: colors.variant.variant90,
        activeBg: colors.variant.variant90,
        indicatorBg: colors.neutral.white100,
        indicatorBorder: colors.variant.variant90
      },
      contentPlaceholder: {
        bgColor: '#eee',
        gradientTint: '#f5f5f5'
      },
      filterLayout: {
        label: colors.primary.primary40,
        badgeBg: colors.warning.warning70,
        bg: colors.neutral.white100,
        border: colors.neutral.neutral95,
        text: colors.variant.variant40,
        checkboxText: colors.variant.variant40,
        radioText: colors.variant.variant40
      },
      tooltip: {
        shadow: '0px 3px 12px 0px rgba(0, 23, 74, 0.12), 0px 1px 4px 0px rgba(0, 23, 74, 0.08), 0px -0.5px 0px 0px rgba(0, 23, 74, 0.02)',
        default: colors.variant.variant40,
        defaultText: colors.variant.variant99,
        error: colors.error.error50,
        errorText: colors.error.error99,
        warning: colors.alert.alert60,
        warningText: colors.alert.alert99,
        info: colors.success.success60,
        infoText: colors.success.success99
      },
      label: {
        text: colors.neutral.neutral10,
        shadow: 'rgba(34, 34, 34, 0.2)',
        bg: colors.variant.variant40
      },
      modal: {
        bg: colors.neutral.white100,
        icon: colors.variant.variant40,
        iconHover: colors.variant.variant20,
        shadow: elevation.el5,
        headerText: colors.primary.primary40,
        headerBg: colors.neutral.white100,
        headerBorder: colors.neutral.neutral90
      },
      inlineDropdown: {
        inputBg: colors.neutral.white100,
        text: colors.neutral.neutral10,
        label: colors.variant.variant40,
        bg: colors.surface.surface1,
        disableText: colors.variant.variant40,
        hoverBg: colors.surface.surface0,
        hoverTextColor: colors.neutral.neutral10,
        icon: colors.primary.primary40
      },
      checkbox: {
        light: {
          textColor: colors.variant.variant50,
          borderColor: colors.neutral.neutral70,
          bgColor: colors.neutral.white100,
          hoverBgColor: colors.neutral.white100,
          hoverBorderColor: colors.primary.primary40,
          checkedBgColor: colors.neutral.white100,
          checkedBorderColor: colors.primary.primary60,
          checkedHoverBgColor: colors.neutral.white100,
          checkedHoverBorderColor: colors.primary.primary40,
          checkBorderColor: colors.primary.primary40,
          disabledBorderColor: colors.neutral.neutral90,
          disabledBgColor: colors.neutral.white100,
          disabledCheckBorderColor: colors.variant.variant40,
          disabledTextColor: colors.variant.variant60,
          disabledCheckedBorderColor: colors.neutral.neutral90,
          disabledCheckedBgColor: colors.neutral.white100,
          asteriskColor: colors.error.error50,
          asteriskDisabledColor: colors.error.error90,
          errorMessageColor: colors.error.error50,
          groupLabelColor: colors.variant.variant50,
          errorTextColor: colors.variant.variant50,
          errorBgColor: colors.neutral.white100,
          errorBorderColor: colors.neutral.neutral70,
          disabledCheckedErrorBgColor: colors.neutral.white100,
          disabledCheckedErrorBorderColor: colors.neutral.neutral90,
          checkedErrorBgColor: colors.neutral.white100,
          checkedErrorBorderColor: colors.primary.primary60
        },
        medium: {
          textColor: colors.variant.variant50,
          borderColor: colors.variant.variant70,
          bgColor: colors.neutral.white100,
          hoverBgColor: colors.neutral.white100,
          hoverBorderColor: colors.primary.primary40,
          checkedBgColor: colors.neutral.white100,
          checkedBorderColor: colors.primary.primary50,
          checkedHoverBgColor: colors.neutral.white100,
          checkedHoverBorderColor: colors.primary.primary40,
          checkBorderColor: colors.primary.primary40,
          disabledBorderColor: colors.primary.primary90,
          disabledBgColor: colors.variant.variant99,
          disabledCheckBorderColor: colors.primary.primary80,
          disabledTextColor: colors.variant.variant60,
          disabledCheckedBorderColor: colors.primary.primary90,
          disabledCheckedBgColor: colors.variant.variant99,
          asteriskColor: colors.error.error50,
          asteriskDisabledColor: colors.error.error90,
          errorMessageColor: colors.error.error50,
          groupLabelColor: colors.variant.variant50,
          errorTextColor: colors.variant.variant50,
          errorBgColor: colors.neutral.white100,
          errorBorderColor: colors.variant.variant70,
          disabledCheckedErrorBgColor: colors.variant.variant99,
          disabledCheckedErrorBorderColor: colors.variant.variant90,
          checkedErrorBgColor: colors.neutral.white100,
          checkedErrorBorderColor: colors.primary.primary50
        },
        dark: {
          textColor: colors.neutral.white100,
          borderColor: colors.variant.variant60,
          bgColor: colors.variant.variant10,
          hoverBgColor: colors.variant.variant10,
          hoverBorderColor: colors.neutral.white100,
          checkedBgColor: colors.neutral.white100,
          checkedBorderColor: colors.neutral.white100,
          checkedHoverBgColor: colors.neutral.white100,
          checkedHoverBorderColor: colors.neutral.white100,
          checkBorderColor: colors.variant.variant30,
          disabledBorderColor: colors.neutral.neutral30,
          disabledBgColor: colors.variant.variant10,
          disabledCheckBorderColor: colors.variant.variant10,
          disabledTextColor: colors.neutral.white100,
          disabledCheckedBorderColor: colors.neutral.neutral40,
          disabledCheckedBgColor: colors.neutral.neutral40,
          asteriskColor: colors.error.error50,
          asteriskDisabledColor: colors.error.error90,
          errorMessageColor: colors.error.error50,
          groupLabelColor: colors.neutral.white100,
          errorTextColor: colors.neutral.white100,
          errorBgColor: colors.variant.variant10,
          errorBorderColor: colors.variant.variant60,
          disabledCheckedErrorBgColor: colors.neutral.neutral40,
          disabledCheckedErrorBorderColor: colors.neutral.neutral40,
          checkedErrorBgColor: colors.neutral.white100,
          checkedErrorBorderColor: colors.neutral.white100
        }
      },
      tagsInput: {
        tagLabel: colors.variant.variant10,
        disabledTagLabel: colors.neutral.neutral40,
        description: colors.variant.variant20,
        tagBg: colors.surface.surface3,
        tagHoverBg: colors.primary.primary90,
        tagRemoveButtonBg: colors.surface.surface3,
        tagRemoveButtonHoverBg: colors.primary.primary90,
        tagRemoveButtonColor: colors.variant.variant40,
        tagRemoveButtonHoverColor: colors.variant.variant30,
        tagInvalidStateBg: colors.error.error40,
        tagInvalidStateHoverBg: colors.error.error50,
        tagInvalidStateRemoveButtonBg: colors.error.error40,
        tagInvalidStateRemoveButtonHoverBg: colors.error.error50,
        tagInvalidStateLabelColor: colors.error.error99,
        tagInvalidStateRemoveButtonColor: colors.error.error95,
        bg: colors.primary.primary99,
        bgHover: colors.surface.surface1,
        border: `${colors.primary.primary99} ${colors.primary.primary99} ${colors.neutral.neutral80} ${colors.primary.primary99}`,
        borderHover: `${colors.primary.primary99} ${colors.primary.primary99} ${colors.primary.primary40} ${colors.primary.primary99}`,
        disabledBorder: colors.variant.variant99,
        focusBg: colors.neutral.white100,
        focusBorder: colors.primary.primary40,
        asteriskColor: colors.error.error40,
        errorMessageColor: colors.error.error40,
        errorStateBg: colors.error.error95,
        errorStateBorder: `${colors.error.error95} ${colors.error.error95} ${colors.error.error40} ${colors.error.error95}`,
        focusErrorBorder: colors.error.error40,
        labelColor: colors.variant.variant40,
        disabledLabelColor: colors.neutral.neutral40,
        disabledBg: colors.variant.variant99,
        disabledTagBg: colors.neutral.neutral90,
        disabledTagRemoveButtonBg: colors.neutral.neutral90,
        disabledTagRemoveButtonColor: colors.neutral.neutral60,
        disabledLabel: colors.neutral.neutral40,
        disabledDescription: colors.variant.variant20,
        placeholder: colors.variant.variant40,
        placeholderHover: colors.variant.variant10,
        placeholderFocus: colors.neutral.neutral60,
        placeholderError: colors.error.error30
      },
      switch: {
        light: {
          bulb: colors.neutral.white100,
          disabledOffBulb: colors.neutral.neutral99,
          disabledOnBulb: colors.primary.primary90,
          onBg: colors.primary.primary40,
          offBg: colors.variant.variant70,
          onDisabledBg: colors.primary.primary70,
          offDisabledBg: colors.neutral.neutral90,
          disabledText: colors.variant.variant80,
          text: colors.variant.variant40,
          titleColor: colors.variant.variant50,
          asteriskColor: colors.error.error50,
          errorMessageColor: colors.error.error50
        },
        medium: {
          bulb: colors.neutral.white100,
          disabledOffBulb: colors.primary.primary95,
          disabledOnBulb: colors.primary.primary90,
          onBg: colors.primary.primary40,
          offBg: colors.variant.variant70,
          onDisabledBg: colors.primary.primary70,
          offDisabledBg: colors.primary.primary80,
          disabledText: colors.variant.variant80,
          text: colors.variant.variant40,
          titleColor: colors.variant.variant50,
          asteriskColor: colors.error.error50,
          errorMessageColor: colors.error.error50
        },
        dark: {
          bulb: colors.neutral.white100,
          disabledOffBulb: colors.neutral.neutral50,
          disabledOnBulb: colors.primary.primary50,
          onBg: colors.primary.primary40,
          offBg: colors.variant.variant70,
          onDisabledBg: colors.primary.primary20,
          offDisabledBg: colors.variant.variant30,
          disabledText: colors.neutral.white100,
          text: colors.neutral.white100,
          titleColor: colors.neutral.white100,
          asteriskColor: colors.error.error50,
          errorMessageColor: colors.error.error50
        }
      },
      radio: {
        light: {
          bg: colors.neutral.white100,
          borderColor: colors.neutral.neutral70,
          hoverBg: colors.neutral.white100,
          hoverBorder: colors.primary.primary40,
          checkedBg: colors.neutral.white100,
          text: colors.variant.variant50,
          checkedBorder: colors.primary.primary40,
          disabledBg: colors.neutral.white100,
          disabledBorder: colors.neutral.neutral90,
          disabledText: colors.variant.variant80,
          disabledCheckedBg: colors.neutral.white100,
          disabledCheckedBorder: colors.neutral.neutral90,
          disabledCheckedCircleBg: colors.neutral.neutral80,
          groupLabelColor: colors.variant.variant50,
          groupErrorMessageColor: colors.error.error50,
          groupAsteriskColor: colors.error.error50
        },
        medium: {
          bg: colors.neutral.white100,
          borderColor: colors.variant.variant70,
          hoverBg: colors.neutral.white100,
          hoverBorder: colors.primary.primary40,
          checkedBg: colors.neutral.white100,
          text: colors.variant.variant50,
          checkedBorder: colors.primary.primary40,
          disabledBg: colors.variant.variant99,
          disabledBorder: colors.primary.primary90,
          disabledText: colors.variant.variant80,
          disabledCheckedBg: colors.variant.variant99,
          disabledCheckedBorder: colors.primary.primary90,
          disabledCheckedCircleBg: colors.primary.primary80,
          groupLabelColor: colors.variant.variant50,
          groupErrorMessageColor: colors.error.error50,
          groupAsteriskColor: colors.error.error50
        },
        dark: {
          bg: colors.variant.variant10,
          borderColor: colors.variant.variant60,
          hoverBg: colors.variant.variant10,
          hoverBorder: colors.neutral.white100,
          checkedBg: colors.variant.variant10,
          text: colors.neutral.white100,
          checkedBorder: colors.neutral.white100,
          disabledBg: colors.variant.variant10,
          disabledBorder: colors.neutral.neutral30,
          disabledText: colors.neutral.white100,
          disabledCheckedBg: colors.variant.variant10,
          disabledCheckedBorder: colors.neutral.neutral30,
          disabledCheckedCircleBg: colors.neutral.neutral40,
          groupLabelColor: colors.neutral.white100,
          groupErrorMessageColor: colors.error.error50,
          groupAsteriskColor: colors.error.error50
        }
      },
      dropdown: {
        light: {
          text: colors.variant.variant10,
          focusText: colors.neutral.neutral10,
          label: colors.variant.variant40,
          bg: colors.primary.primary99,
          border: colors.variant.variant80,
          focusBg: colors.neutral.white100,
          hoverBg: colors.surface.surface3,
          hoverBorder: colors.primary.primary40,
          hoverHighlightBg: colors.surface.surface1,
          optionsBg: colors.neutral.white100,
          hoverOptionColor: colors.surface.surface3,
          hoverOptionIconColor: colors.primary.primary40,
          focusInput: colors.primary.primary40,
          disableText: colors.neutral.neutral10,
          disableBg: colors.variant.variant99,
          disableBorder: colors.variant.variant99,
          disabledLabel: colors.variant.variant40,
          disabledDescription: colors.variant.variant40,
          multiBg: colors.surface.surface3,
          multiHoverBg: colors.surface.surface3,
          multiTextColor: colors.neutral.neutral10,
          multiRemoveIcon: colors.variant.variant40,
          multiRemoveIconHover: colors.neutral.white100,
          disableMultiBg: colors.variant.variant90,
          selectedIcon: colors.primary.primary40,
          asterisk: colors.error.error40,
          disabledAsterisk: colors.error.error95,
          errorMessageColor: colors.error.error20,
          errorStateBg: colors.error.error95,
          errorBorderColor: `${colors.error.error95} ${colors.error.error95} ${colors.error.error40} ${colors.error.error95}`,
          focusErrorBorderColor: colors.error.error40,
          placeholder: colors.variant.variant40,
          description: colors.variant.variant40,
          iconColor: colors.variant.variant40,
          iconFocusColor: colors.primary.primary40,
          iconDisabledColor: colors.neutral.neutral80,
          iconErrorColor: colors.error.error40,
          customOptionIcon: colors.primary.primary40
        },
        medium: {
          text: colors.neutral.neutral10,
          focusText: colors.neutral.neutral10,
          label: colors.variant.variant40,
          bg: colors.neutral.white100,
          border: colors.neutral.neutral80,
          focusBg: colors.neutral.white100,
          hoverBg: colors.surface.surface3,
          hoverBorder: colors.primary.primary40,
          hoverHighlightBg: colors.neutral.white100,
          optionsBg: colors.neutral.white100,
          hoverOptionColor: colors.surface.surface3,
          hoverOptionIconColor: colors.primary.primary40,
          focusInput: colors.primary.primary40,
          disableText: colors.neutral.neutral10,
          disableBg: colors.neutral.neutral99,
          disableBorder: colors.neutral.neutral99,
          disabledLabel: colors.variant.variant40,
          disabledDescription: colors.variant.variant40,
          multiBg: colors.neutral.white100,
          multiHoverBg: colors.neutral.white100,
          multiTextColor: colors.neutral.neutral10,
          multiRemoveIcon: colors.variant.variant40,
          multiRemoveIconHover: colors.neutral.white100,
          disableMultiBg: colors.variant.variant90,
          selectedIcon: colors.primary.primary40,
          asterisk: colors.error.error40,
          disabledAsterisk: colors.error.error95,
          errorMessageColor: colors.error.error20,
          errorStateBg: colors.error.error95,
          errorBorderColor: `${colors.error.error95} ${colors.error.error95} ${colors.error.error40} ${colors.error.error95}`,
          focusErrorBorderColor: colors.error.error40,
          placeholder: colors.neutral.neutral40,
          description: colors.variant.variant40,
          iconColor: colors.variant.variant40,
          iconFocusColor: colors.primary.primary40,
          iconDisabledColor: colors.neutral.neutral80,
          iconErrorColor: colors.error.error40,
          customOptionIcon: colors.primary.primary40
        },
        dark: {
          text: colors.neutral.white100,
          focusText: colors.neutral.neutral10,
          label: colors.neutral.white100,
          bg: colors.variant.variant20,
          border: colors.neutral.neutral40,
          focusBg: colors.neutral.white100,
          hoverBg: colors.variant.variant30,
          optionsBg: colors.variant.variant20,
          hoverOptionColor: colors.neutral.white100,
          hoverOptionIconColor: colors.neutral.white100,
          focusInput: colors.primary.primary60,
          disableText: colors.neutral.neutral80,
          disableBg: colors.variant.variant20,
          disableBorder: colors.variant.variant20,
          disabledLabel: colors.neutral.white100,
          disabledDescription: colors.neutral.white100,
          multiBg: colors.variant.variant20,
          multiHoverBg: colors.variant.variant20,
          multiTextColor: colors.neutral.white100,
          multiRemoveIcon: colors.variant.variant40,
          multiRemoveIconHover: colors.neutral.white100,
          disableMultiBg: colors.variant.variant20,
          selectedIcon: colors.neutral.white100,
          asterisk: colors.error.error40,
          disabledAsterisk: colors.error.error95,
          errorMessageColor: colors.error.error20,
          errorStateBg: colors.error.error95,
          errorBorderColor: `${colors.error.error95} ${colors.error.error95} ${colors.error.error40} ${colors.error.error95}`,
          focusErrorBorderColor: colors.error.error40,
          placeholder: colors.neutral.white100,
          description: colors.neutral.white100,
          iconColor: colors.neutral.white100,
          iconFocusColor: colors.primary.primary40,
          iconDisabledColor: colors.neutral.white100,
          iconErrorColor: colors.error.error40,
          customOptionIcon: colors.neutral.white100
        }
      },
      textField: {
        light: {
          color: colors.neutral.neutral10,
          label: colors.variant.variant40,
          description: colors.variant.variant40,
          bg: colors.surface.surface1,
          border: `${colors.surface.surface1} ${colors.surface.surface1} ${colors.variant.variant80} ${colors.surface.surface1}`,
          focusColor: colors.neutral.neutral10,
          focusBg: colors.neutral.white100,
          focusBorder: colors.primary.primary40,
          disabledBorder: colors.variant.variant99,
          disabledText: colors.neutral.neutral10,
          disabledBg: colors.variant.variant99,
          disabledLabel: colors.variant.variant40,
          disabledDescription: colors.variant.variant40,
          asterisk: colors.error.error40,
          disabledAsterisk: colors.error.error95,
          checking: colors.primary.primary40,
          validBorder: colors.primary.primary40,
          errorBorder: `${colors.error.error95} ${colors.error.error95} ${colors.error.error40} ${colors.error.error95}`,
          focusErrorBorder: colors.error.error40,
          errorBg: colors.error.error95,
          errorColor: colors.error.error20,
          passwordIcon: colors.primary.primary40,
          passwordDisabledIcon: '#c8c8c8',
          placeholder: colors.variant.variant40,
          focusPlaceholder: colors.variant.variant40,
          iconColor: colors.variant.variant40,
          iconFocusColor: colors.primary.primary40,
          iconDisabledColor: colors.variant.variant70,
          iconErrorColor: colors.error.error50
        },
        medium: {
          color: colors.neutral.neutral10,
          label: colors.variant.variant40,
          description: colors.variant.variant40,
          bg: colors.neutral.white100,
          border: `${colors.neutral.white100} ${colors.neutral.white100} ${colors.neutral.neutral80} ${colors.neutral.white100}`,
          focusColor: colors.neutral.neutral10,
          focusBg: colors.neutral.white100,
          focusBorder: colors.primary.primary40,
          disabledBorder: colors.neutral.neutral99,
          disabledText: colors.neutral.neutral10,
          disabledBg: colors.neutral.neutral99,
          disabledLabel: colors.variant.variant40,
          disabledDescription: colors.variant.variant40,
          asterisk: colors.error.error40,
          disabledAsterisk: colors.error.error95,
          checking: colors.primary.primary40,
          validBorder: colors.primary.primary40,
          errorBorder: `${colors.error.error95} ${colors.error.error95} ${colors.error.error40} ${colors.error.error95}`,
          focusErrorBorder: colors.error.error40,
          errorBg: colors.error.error95,
          errorColor: colors.error.error20,
          passwordIcon: colors.primary.primary40,
          passwordDisabledIcon: '#c8c8c8',
          placeholder: colors.variant.variant40,
          focusPlaceholder: colors.variant.variant40,
          iconColor: colors.variant.variant40,
          iconFocusColor: colors.primary.primary40,
          iconDisabledColor: colors.variant.variant70,
          iconErrorColor: colors.error.error50
        },
        dark: {
          color: colors.neutral.white100,
          label: colors.neutral.white100,
          description: colors.neutral.white100,
          bg: colors.variant.variant20,
          border: `${colors.variant.variant20} ${colors.variant.variant20} ${colors.neutral.neutral40} ${colors.variant.variant20}`,
          focusColor: colors.neutral.neutral10,
          focusBg: colors.neutral.white100,
          focusBorder: colors.primary.primary60,
          disabledBorder: colors.variant.variant20,
          disabledText: colors.neutral.neutral80,
          disabledBg: colors.variant.variant20,
          disabledLabel: colors.neutral.white100,
          disabledDescription: colors.neutral.white100,
          asterisk: colors.error.error40,
          disabledAsterisk: colors.error.error95,
          checking: colors.primary.primary40,
          validBorder: colors.primary.primary40,
          errorBorder: `${colors.error.error20} ${colors.error.error20} ${colors.error.error40} ${colors.error.error20}`,
          focusErrorBorder: colors.error.error40,
          errorBg: colors.error.error20,
          errorColor: colors.neutral.white100,
          passwordIcon: colors.primary.primary40,
          passwordDisabledIcon: '#c8c8c8',
          placeholder: colors.neutral.neutral80,
          focusPlaceholder: colors.neutral.neutral80,
          iconColor: colors.neutral.white100,
          iconFocusColor: colors.primary.primary40,
          iconDisabledColor: colors.variant.variant70,
          iconErrorColor: colors.error.error50
        }
      },
      numericInput: {
        light: {
          text: colors.neutral.neutral10,
          label: colors.variant.variant40,
          description: colors.variant.variant40,
          bg: colors.surface.surface1,
          border: `${colors.surface.surface1} ${colors.surface.surface1} ${colors.variant.variant80} ${colors.surface.surface1}`,
          focusColor: colors.neutral.neutral10,
          focusBg: colors.neutral.white100,
          focusBorder: colors.primary.primary40,
          disabledBg: colors.variant.variant99,
          disabledText: colors.neutral.neutral10,
          disabledBorder: colors.variant.variant99,
          disabledLabel: colors.variant.variant40,
          disabledDescription: colors.variant.variant40,
          asteriskColor: colors.error.error40,
          errorMessageColor: colors.error.error20,
          errorBg: colors.error.error95,
          errorBorder: `${colors.error.error95} ${colors.error.error95} ${colors.error.error40} ${colors.error.error95}`,
          focusErrorBorder: colors.error.error40,
          errorColor: colors.error.error20,
          placeholder: colors.variant.variant40
        },
        medium: {
          text: colors.neutral.neutral10,
          label: colors.variant.variant40,
          description: colors.variant.variant40,
          bg: colors.neutral.white100,
          border: `${colors.neutral.white100} ${colors.neutral.white100} ${colors.neutral.neutral80} ${colors.neutral.white100}`,
          focusColor: colors.neutral.neutral10,
          focusBg: colors.neutral.white100,
          focusBorder: colors.primary.primary40,
          disabledBg: colors.neutral.neutral99,
          disabledText: colors.neutral.neutral10,
          disabledBorder: colors.neutral.neutral99,
          disabledLabel: colors.variant.variant40,
          disabledDescription: colors.variant.variant40,
          asteriskColor: colors.error.error40,
          errorMessageColor: colors.error.error20,
          errorBg: colors.error.error95,
          errorBorder: `${colors.error.error95} ${colors.error.error95} ${colors.error.error40} ${colors.error.error95}`,
          focusErrorBorder: colors.error.error40,
          errorColor: colors.error.error20,
          placeholder: colors.variant.variant40
        },
        dark: {
          text: colors.neutral.white100,
          label: colors.neutral.white100,
          description: colors.neutral.white100,
          bg: colors.variant.variant20,
          border: `${colors.variant.variant20} ${colors.variant.variant20} ${colors.neutral.neutral40} ${colors.variant.variant20}`,
          focusColor: colors.neutral.neutral10,
          focusBg: colors.neutral.white100,
          focusBorder: colors.primary.primary60,
          disabledBg: colors.variant.variant20,
          disabledText: colors.neutral.neutral80,
          disabledBorder: colors.variant.variant20,
          disabledLabel: colors.neutral.white100,
          disabledDescription: colors.neutral.white100,
          asteriskColor: colors.error.error40,
          errorMessageColor: colors.neutral.white100,
          errorBg: colors.error.error20,
          errorColor: colors.neutral.white100,
          errorBorder: `${colors.error.error20} ${colors.error.error20} ${colors.error.error40} ${colors.error.error20}`,
          focusErrorBorder: colors.error.error40,
          placeholder: colors.neutral.neutral80
        }
      },
      overlay: {
        bg: colors.surface.surface4,
        opacity: '0.65'
      },
      pagination: {
        text: colors.variant.variant40,
        currentPageText: colors.neutral.neutral10,
        activeText: colors.primary.primary40,
        pagerText: colors.neutral.neutral10,
        pagerBg: colors.surface.surface1,
        activeBagde: colors.primary.primary40,
        line: colors.variant.variant95,
        label: colors.neutral.neutral40,
        totalPagesLabel: colors.neutral.neutral10,
        action: colors.variant.variant40,
        actionHover: colors.primary.primary40,
        actionDisabled: colors.neutral.neutral80
      },
      calendar: {
        bg: colors.neutral.white100,
        textColor: colors.neutral.neutral10,
        textLightGrayColor: colors.primary.primary80,
        border: colors.neutral.white100,
        hoverBg: colors.neutral.white100,
        hoverBorder: colors.primary.primary40,
        activeBg: colors.primary.primary40,
        activeTextColor: colors.neutral.white100,
        activeBorder: colors.primary.primary40,
        weekBorder: colors.surface.surface4,
        monthBg: colors.neutral.white100,
        yearTextColor: colors.neutral.neutral10,
        activeYear: colors.primary.primary30,
        weekTextColor: colors.variant.variant40,
        titleColor: colors.variant.variant40,
        titleHoverColor: colors.variant.variant20,
        titleHoverBg: colors.neutral.white100,
        disabledColor: colors.neutral.neutral60,
        disabledBg: colors.neutral.white100,
        disabledBorder: colors.neutral.white100,
        disabledActiveColor: colors.neutral.white100,
        disabledActiveBg: colors.primary.primary80,
        disabledActiveBorder: colors.primary.primary80,
        controlsColor: colors.variant.variant40,
        controlsColorHover: colors.variant.variant20,
        boxShadow: elevation.el2
      },
      dateDropdown: {
        text: colors.variant.variant10,
        label: colors.variant.variant40,
        bg: colors.primary.primary99,
        border: `${colors.primary.primary99} ${colors.primary.primary99} ${colors.variant.variant80} ${colors.primary.primary99}`,
        hoverBg: colors.surface.surface1,
        hoverBorder: `${colors.primary.primary99} ${colors.primary.primary99} ${colors.primary.primary40} ${colors.primary.primary99}`,
        activeBg: colors.neutral.white100,
        activeBorder: colors.primary.primary40,
        disabledBg: colors.variant.variant99,
        disabledBorder: colors.variant.variant99,
        disabledLabel: colors.variant.variant40,
        disabledDescription: colors.variant.variant40,
        popoverBg: colors.surface.surface1,
        closeIcon: colors.variant.variant40,
        asteriskColor: colors.error.error40,
        errorMessage: colors.error.error40,
        errorStateBg: colors.error.error95,
        errorBorderColor: `${colors.error.error95} ${colors.error.error95} ${colors.error.error40} ${colors.error.error95}`,
        focusErrorBorderColor: colors.error.error40,
        placeholder: colors.variant.variant40,
        errorPlaceholder: colors.error.error40,
        description: colors.variant.variant20,
        iconColor: colors.variant.variant40,
        iconFocusColor: colors.primary.primary40,
        iconDisabledColor: colors.neutral.neutral80,
        iconErrorColor: colors.error.error40
      },
      datePicker: {
        background: colors.surface.surface1,
        text: colors.neutral.neutral10,
        active: colors.primary.primary40,
        activeContrast: colors.neutral.white100,
        selected: colors.primary.primary90,
        muted: colors.variant.variant70,
        disabled: colors.variant.variant40,
        navigation: colors.variant.variant40,
        separator: colors.variant.variant80
      },
      searchInput: {
        light: {
          bg: colors.surface.surface1,
          border: `${colors.surface.surface1} ${colors.surface.surface1} ${colors.variant.variant80} ${colors.surface.surface1}`,
          focusBg: colors.neutral.white100,
          focusBorder: colors.primary.primary40,
          clearIcon: colors.variant.variant40,
          focusClearIcon: colors.primary.primary40,
          searchIcon: colors.variant.variant40,
          focusSearchIcon: colors.primary.primary40
        },
        medium: {
          bg: colors.neutral.white100,
          border: `${colors.neutral.white100} ${colors.neutral.white100} ${colors.neutral.neutral80} ${colors.neutral.white100}`,
          focusBg: colors.neutral.white100,
          focusBorder: colors.primary.primary40,
          clearIcon: colors.variant.variant40,
          focusClearIcon: colors.primary.primary40,
          searchIcon: colors.variant.variant40,
          focusSearchIcon: colors.primary.primary40
        },
        dark: {
          bg: colors.variant.variant20,
          border: `${colors.variant.variant20} ${colors.variant.variant20} ${colors.neutral.neutral40} ${colors.variant.variant20}`,
          focusBg: colors.neutral.white100,
          focusBorder: colors.primary.primary60,
          clearIcon: colors.neutral.white100,
          focusClearIcon: colors.primary.primary40,
          searchIcon: colors.neutral.white100,
          focusSearchIcon: colors.primary.primary40
        }
      },
      stepper: {
        labelActive: colors.primary.primary40,
        labelActiveHover: colors.primary.primary40,
        labelDisabled: colors.variant.variant40,
        labelDisabledHover: colors.primary.primary40,
        stepCircleLabelActive: colors.neutral.white100,
        stepCircleLabelDisabled: colors.variant.variant40,
        stepCircleActiveBg: colors.primary.primary40,
        stepCircleActiveBgHover: colors.primary.primary40,
        stepCircleCompletedBg: colors.success.success70,
        stepCircleDisabledBg: colors.variant.variant95,
        stepCircleDisabledBgHover: colors.primary.primary40,
        chevronActive: colors.neutral.neutral15,
        chevronDisabled: colors.neutral.neutral80
      },
      badge: {
        backgroundColor: {
          default: colors.variant.variant50,
          success: colors.success.success60,
          highlight: colors.primary.primary40,
          error: colors.error.error50,
          alert: colors.alert.alert60,
          accent: colors.accent.accent80,
          warning: colors.warning.warning80,
          disabled: colors.neutral.neutral90
        },
        badgeValue: {
          default: colors.neutral.white100,
          success: colors.neutral.white100,
          highlight: colors.neutral.white100,
          error: colors.neutral.white100,
          alert: colors.neutral.white100,
          accent: colors.accent.accent10,
          warning: colors.warning.warning20,
          disabled: colors.neutral.neutral40
        }
      },
      textTag: {
        backgroundColor: {
          default: colors.variant.variant95,
          success: colors.success.success95,
          highlight: colors.primary.primary90,
          error: colors.error.error90,
          alert: colors.alert.alert90,
          accent: colors.accent.accent90,
          warning: colors.warning.warning90,
          disabled: colors.variant.variant95
        },
        textColor: {
          default: colors.neutral.neutral30,
          success: colors.neutral.success30,
          highlight: colors.primary.primary30,
          error: colors.error.error30,
          alert: colors.alert.alert30,
          accent: colors.accent.accent30,
          warning: colors.warning.warning30,
          disabled: colors.neutral.neutral50
        }
      },
      progressBar: {
        barBackground: colors.neutral.neutral99,
        light: {
          label: colors.neutral.neutral50,
          barColor: colors.primary.primary30
        },
        dark: {
          label: colors.neutral.white100,
          barColor: colors.primary.primary50
        }
      },
      slider: {
        background: colors.neutral.neutral99,
        active: colors.primary.primary40
      },
      contentSwitcher: {
        backgroundColor: colors.surface.surface1,
        itemTextColor: colors.variant.variant10,
        selectedItemTextColor: colors.neutral.white100,
        hoverBackgroundColor: colors.surface.surface3,
        selectedBackgroundColor: colors.primary.primary40,
        dividerColor: colors.surface.surface3
      },
      chip: {
        textColor: colors.neutral.neutral20,
        background: colors.neutral.white100,
        border: colors.variant.variant90,
        textColorHover: colors.neutral.neutral20,
        backgroundHover: colors.surface.surface0,
        borderHover: colors.surface.surface5,
        disabledTextColor: colors.neutral.neutral50,
        disabledBackground: colors.neutral.white100,
        disabledBorder: colors.neutral.neutral90,
        selectedTextColor: colors.primary.primary30,
        selectedBackground: colors.primary.primary95,
        selectedBorder: colors.primary.primary95,
        selectedTextColorHover: colors.primary.primary30,
        selectedBackgroundHover: colors.surface.surface3,
        selectedBorderHover: colors.surface.surface3,
        selectedDisabledTextColor: colors.neutral.neutral40,
        selectedDisabledBackground: colors.neutral.neutral95,
        selectedDisabledBorder: colors.neutral.neutral95,
        closeIconColor: colors.variant.variant40,
        closeIconColorHover: colors.variant.variant20,
        selectedCloseIconColor: colors.primary.primary30,
        selectedCloseIconColorHover: colors.primary.primary20,
        disabledCloseIconColor: colors.neutral.neutral70,
        selectedDisabledCloseIconColor: colors.neutral.neutral70,
        leadingIconColor: colors.variant.variant40,
        selectedLeadingIconColor: colors.primary.primary30,
        disabledLeadingIconColor: colors.neutral.neutral70,
        selectedDisabledLeadingIconColor: colors.neutral.neutral60
      },
      iconButton: {
        iconColor: colors.variant.variant40,
        backgroundColor: 'transparent',
        iconHoverColor: colors.primary.primary40,
        backgroundHoverColor: colors.primary.primary99,
        iconActiveColor: colors.primary.primary40,
        backgroundActiveColor: 'transparent',
        iconDisabledColor: colors.neutral.neutral70,
        backgroundDisabledColor: 'transparent',
        iconSelectedColor: colors.primary.primary40
      }
    },
    ...extra
  };
  return (0, _lodash.default)(theme, overrides);
};
exports.createPrizmNextTheme = createPrizmNextTheme;
const prizmNext = exports.prizmNext = createPrizmNextTheme();